<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <div class="mb-1">
        <azul-card
          :idcontrato="data.idcontrato"
          @saveCard="saveCard"
          @cardSelected="cardSelected"
        />
      </div>
      <form
        id="paymentForm"
        :action="azulPaymentUrl"
        method="post"
        name="paymentForm"
      >
        <input
          id="SaveToDataVault"
          v-model="SaveToDataVault"
          type="hidden"
          name="SaveToDataVault"
        >
        <input
          id="DataVaultToken"
          v-model="DataVaultToken"
          type="hidden"
          name="DataVaultToken"
        >
        <input
          id="MerchantId"
          v-model="MerchantId"
          type="hidden"
          name="MerchantId"
        >
        <input
          id="MerchantName"
          v-model="MerchantName"
          type="hidden"
          name="MerchantName"
        >
        <input
          id="MerchantType"
          v-model="MerchantType"
          type="hidden"
          name="MerchantType"
        >
        <input
          id="CurrencyCode"
          v-model="CurrencyCode"
          type="hidden"
          name="CurrencyCode"
        >
        <input
          id="OrderNumber"
          v-model="OrderNumber"
          type="hidden"
          name="OrderNumber"
        >
        <input
          id="Amount"
          v-model="Amount"
          type="hidden"
          name="Amount"
        >
        <input
          id="ITBIS"
          v-model="ITBIS"
          type="hidden"
          name="ITBIS"
        >
        <input
          id="ApprovedUrl"
          v-model="ApprovedUrl"
          type="hidden"
          name="ApprovedUrl"
        >
        <input
          id="DeclinedUrl"
          v-model="DeclinedUrl"
          type="hidden"
          name="DeclinedUrl"
        >
        <input
          id="CancelUrl"
          v-model="CancelUrl"
          type="hidden"
          name="CancelUrl"
        >
        <input
          id="UseCustomField1"
          v-model="UseCustomField1"
          type="hidden"
          name="UseCustomField1"
        >
        <input
          id="CustomField1Label"
          v-model="CustomField1Label"
          type="hidden"
          name="CustomField1Label"
        >
        <input
          id="CustomField1Value"
          v-model="CustomField1Value"
          type="hidden"
          name="CustomField1Value"
        >
        <input
          id="UseCustomField2"
          v-model="UseCustomField2"
          type="hidden"
          name="UseCustomField2"
        >
        <input
          id="CustomField2Label"
          v-model="CustomField2Label"
          type="hidden"
          name="CustomField2Label"
        >
        <input
          id="CustomField2Value"
          v-model="CustomField2Value"
          type="hidden"
          name="CustomField2Value"
        >
        <input
          id="AuthHash"
          v-model="AuthHash"
          type="hidden"
          name="AuthHash"
        >
        <div class="mt-2">
          <b-button
            type="button"
            variant="primary"
            block
            size="lg"
            @click="save"
          >
            <feather-icon
              icon="LockIcon"
              class="mr-50"
            />Continuar
            el pago
          </b-button>
        </div>
      </form>
    </b-overlay>
  </div>
</template>
<script>
import { BButton, BOverlay } from "bootstrap-vue"
import AzulCard from "./AzulCard.vue"

export default {
  components: {
    BOverlay,
    BButton,
    AzulCard,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
    balancePesos: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      data: {
        idcontrato: null,
        codigo: null,
        apenom: null,
        balance_pesos: 0,
      },
      card: false,
      cardToken: "",
      SaveToDataVault: 0,
      DataVaultToken: "",
      MerchantId: "",
      MerchantName: "",
      MerchantType: "",
      CurrencyCode: "$",
      OrderNumber: "",
      Amount: "",
      ITBIS: "",
      ApprovedUrl: "",
      DeclinedUrl: "",
      CancelUrl: "",
      UseCustomField1: "",
      CustomField1Label: "",
      CustomField1Value: "",
      UseCustomField2: "",
      CustomField2Label: "",
      CustomField2Value: "",
      AuthHash: "",
    }
  },
  computed: {
    azulPaymentUrl() {
      return process.env.VUE_APP_AZUL_PAYMENT_URL
    },
  },
  created() {
    this.data.idcontrato = this.contract.idcontrato
    this.data.codigo = this.contract.codigo
    this.data.apenom = this.contract.apenom
    this.data.balance_pesos = this.balancePesos
  },
  methods: {
    saveCard(card) {
      this.card = card
    },
    cardSelected(card) {
      this.cardToken = card.token ?? ""
    },
    save() {
      this.show = true
      this.$http
        .post("/payment-azul", {
          idcontrato: this.data.idcontrato,
          codigo: this.data.codigo,
          apenom: this.data.apenom,
          balance_pesos: this.data.balance_pesos,
          idusuario: this.userData.id,
          card: this.card ? 1 : 0,
          cardToken: this.cardToken,
        })
        .then((response) => {
          const data = response.data.data || {}

          this.SaveToDataVault = data.SaveToDataVault
          this.DataVaultToken = data.DataVaultToken
          this.MerchantId = data.MerchantId
          this.MerchantName = data.MerchantName
          this.MerchantType = data.MerchantType
          this.CurrencyCode = data.CurrencyCode
          this.OrderNumber = data.OrderNumber
          this.Amount = data.Amount
          this.ITBIS = data.ITBIS
          this.ApprovedUrl = data.ApprovedUrl
          this.DeclinedUrl = data.DeclinedUrl
          this.CancelUrl = data.CancelUrl
          this.UseCustomField1 = data.UseCustomField1
          this.CustomField1Label = data.CustomField1Label
          this.CustomField1Value = data.CustomField1Value
          this.UseCustomField2 = data.UseCustomField2
          this.CustomField2Label = data.CustomField2Label
          this.CustomField2Value = data.CustomField2Value
          this.AuthHash = data.AuthHash

          this.generateForm()
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: error.response
              ? error.response.data.error
              : error.message,
            icon: "error",
          })
        })
        .finally(() => {
          this.show = false
        })
    },
    generateForm() {
      document.getElementById("SaveToDataVault").value =
                this.SaveToDataVault
      document.getElementById("MerchantId").value = this.MerchantId
      document.getElementById("MerchantName").value = this.MerchantName
      document.getElementById("MerchantType").value = this.MerchantType
      document.getElementById("CurrencyCode").value = this.CurrencyCode
      document.getElementById("OrderNumber").value = this.OrderNumber
      document.getElementById("Amount").value = this.Amount
      document.getElementById("ITBIS").value = this.ITBIS
      document.getElementById("ApprovedUrl").value = this.ApprovedUrl
      document.getElementById("DeclinedUrl").value = this.DeclinedUrl
      document.getElementById("CancelUrl").value = this.CancelUrl
      document.getElementById("UseCustomField1").value =
                this.UseCustomField1
      document.getElementById("CustomField1Label").value =
                this.CustomField1Label
      document.getElementById("CustomField1Value").value =
                this.CustomField1Value
      document.getElementById("UseCustomField2").value =
                this.UseCustomField2
      document.getElementById("CustomField2Label").value =
                this.CustomField2Label
      document.getElementById("CustomField2Value").value =
                this.CustomField2Value
      document.getElementById("AuthHash").value = this.AuthHash

      document.getElementById("paymentForm").submit()
    },
  },
}
</script>
